import React from 'react';
import { CollapseFilterWrapper } from '../../../components/sidebar-filters/CollapseFilterWrapper';
import { DateRangeWithCustomOptionFilterSelect } from '../../../components/sidebar-filters/filter-select/DateRangeWithCustomOptionFilterSelect';
import { ProgramFilterSelect } from '../../../components/sidebar-filters/filter-select/ProgramFilterSelect';
import { useSidebarFilterOptionsContext } from '../../energyUsageData/sidebar/context/SidebarFilterOptionsContext';
import { AlertTrackParticipationStatusSelect } from '../../../components/sidebar-filters/filter-select/AlertTrackResponseStatusFilterSelect';
import {
    IEventCompanyParticipationSidebarFilters,
    useEventCompanyParticipationSidebarFiltersContext,
} from './EventCompanyParticipationSidebarFiltersContext';

export const EventCompanyParticipationFilterKeys = {
    // Filters
    period: 'period',
    event_programs: 'event_programs',
    participation_statuses: 'participation_statuses',
} as const;

export type TEventCompanyParticipationFilterKey = (typeof EventCompanyParticipationFilterKeys)[keyof typeof EventCompanyParticipationFilterKeys];

export const EventCompanyParticipationFilterLabels = {
    [EventCompanyParticipationFilterKeys.period]: 'Period',
    [EventCompanyParticipationFilterKeys.event_programs]: 'Program',
    [EventCompanyParticipationFilterKeys.participation_statuses]: 'Participation Status',
} as const;

interface IEventCompanyParticipationSidebarFiltersProps {
    onFilterChange: (filters: IEventCompanyParticipationSidebarFilters) => void;
}

export const EventCompanyParticipationSidebarFilters: React.FC<IEventCompanyParticipationSidebarFiltersProps> = ({ onFilterChange }) => {
    const { filters, handleFilterChange } = useEventCompanyParticipationSidebarFiltersContext();
    const {
        isLoading: isFiltersLoading,
        eventCompanyParticipationProgramOptions,
        eventCompanyParticipationPeriodOptions,
        alertTrackParticipationStatusOptions,
    } = useSidebarFilterOptionsContext();

    const handleEventCompanyParticipationFilterChange = (key: string, value: unknown) => {
        handleFilterChange(key, value);
        onFilterChange({ ...filters, [key]: value });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto' }}>
            {/* Filters */}
            <CollapseFilterWrapper label="Filters">
                <DateRangeWithCustomOptionFilterSelect
                    height={110}
                    label={EventCompanyParticipationFilterLabels[EventCompanyParticipationFilterKeys.period]}
                    value={filters[EventCompanyParticipationFilterKeys.period] || null}
                    onChange={value => handleEventCompanyParticipationFilterChange(EventCompanyParticipationFilterKeys.period, value)}
                    options={eventCompanyParticipationPeriodOptions}
                    allowClear={false}
                    tooltipTitle="Period must be selected, due to large amount of data"
                    maxRangeInDays={90}
                />
                <ProgramFilterSelect
                    label={EventCompanyParticipationFilterLabels[EventCompanyParticipationFilterKeys.event_programs]}
                    value={filters[EventCompanyParticipationFilterKeys.event_programs] || []}
                    onChange={value => handleEventCompanyParticipationFilterChange(EventCompanyParticipationFilterKeys.event_programs, value)}
                    options={eventCompanyParticipationProgramOptions}
                    isLoading={isFiltersLoading}
                />
                <AlertTrackParticipationStatusSelect
                    label={EventCompanyParticipationFilterLabels[EventCompanyParticipationFilterKeys.participation_statuses]}
                    value={filters[EventCompanyParticipationFilterKeys.participation_statuses] || []}
                    onChange={val => handleEventCompanyParticipationFilterChange(EventCompanyParticipationFilterKeys.participation_statuses, val)}
                    options={alertTrackParticipationStatusOptions}
                />
            </CollapseFilterWrapper>
        </div>
    );
};
